// extracted by mini-css-extract-plugin
module.exports = {"jumpLinks":"JumpLinks-module--jump-links--2UgLL"};